module.exports = __webpack_public_path__ + "img/map_Z3.7.C.03.b8acb90c.svg";